module.exports = __webpack_public_path__ + "img/a10.0fcecfe5.webp";